import React, { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Navigation from './Components/Nav/nav';
import Footer from './Components/Footer/footer';
import PageSpinner from './Components/Shared/PageSpinner';
import OfflineBanner from './Components/Shared/OfflineBanner';
import useMetaPageView from './hooks/useMetaPageView';
import useRouteTitle from './hooks/useRouteTitle';
// Floating "Ask us anything" widget — paused while the /ourplaces Megan
// workspace is in private beta, so testers meet one assistant, not two.
// Restore by uncommenting this import and the element below.
// import ChatAssistant from './Components/ChatAssistant/ChatAssistant';

/**
 * `children` is only passed by the router's errorElement, which needs the same
 * header and footer around a page it renders itself. Everything else comes
 * through the Outlet.
 */
const Layout = ({ children }) => {
  useMetaPageView();
  useRouteTitle();

  return (
    <div className="Body">
      {/* First thing in the tab order: keyboard and screen-reader users had to
          step through the whole header on every page to reach the content. */}
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <OfflineBanner />

      <Navigation />

      <main id="main-content" tabIndex={-1}>
        {children ?? (
          <Suspense fallback={<PageSpinner minHeight="70vh" />}>
            <Outlet />
          </Suspense>
        )}
      </main>

      <Footer />
      {/* <ChatAssistant /> */}

      {/* Client-side navigation left the browser wherever the previous page was
          scrolled to, so following a link from halfway down the home page opened
          the next one halfway down. This resets on navigation and restores the
          old position on back/forward. */}
      <ScrollRestoration />
    </div>
  );
};

export default Layout;
